<template>
  <div id="Users">
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
      :title="$t('reports.cloud.title')"
      :subtitle="$t('reports.vcloud.col.details')"
    />
    <br /><br />

    <div id="VCloudList">
      <div class="listTicket">
        <!-- Filters / Pickers -->
        <div class="mdl-grid">
          <!-- Date (single day) -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="detailDate"
                class="not-empty"
                v-model="detailDate"
                style="background-color: white"
                @change="fetchDetails()"
              />
              <label>{{ $t("reports.filter.date") }}</label>
            </div>
          </div>

          <!-- Project selector -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <select
                v-model="projectName"
                @change="onProjectChange"
                :class="{ 'not-empty': !!projectName }"
                style="background-color: white"
              >
                <option
                  v-for="(project, idx) in vProjectsList"
                  :key="idx"
                  :value="project"
                >
                  {{ project.label }}
                </option>
              </select>
              <label>{{ $t("reports.vcloudDetail.project") }}</label>
            </div>
          </div>
        </div>
        <!-- Tabs VM / Storage -->
        <div class="mdl-tabs mdl-js-tabs mdl-js-ripple-effect">
          <div class="mdl-tabs__tab-bar">
            <span
              class="mdl-tabs__tab tabOne is-active"
              id="tabOne"
              @click="switchTab(1)"
            >
              {{ $t("reports.vcloudDetail.vm") }}
              <div class="line"></div>
            </span>
            <span
              class="mdl-tabs__tab tabTwo"
              id="tabTwo"
              @click="switchTab(2)"
            >
              {{ $t("reports.vcloudDetail.storage") }}
              <div class="line"></div>
            </span>
          </div>

          <!-- VM Panel -->
          <div class="mdl-tabs__panel tabOne is-active">
            <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <table class="cloud-report-table">
                  <thead v-if="!$IsMobile()">
                  <tr>
                    <th class="col-description">
                      {{ $t("reports.vcloudDetail.vmId") }}
                    </th>
                    <th class="col-hours">
                      {{ $t("reports.vcloud.col.cpuNumber") }}
                    </th>
                    <th class="col-pph">
                      {{ $t("reports.vcloud.col.cpuPrice") }}
                    </th>
                    <th class="col-hours">
                      {{ $t("reports.vcloud.col.memoryUsage") }}
                    </th>
                    <th class="col-pph">
                      {{ $t("reports.vcloud.col.memoryPrice") }}
                    </th>
                    <th class="col-description">
                      {{ $t("reports.vcloud.col.templateUsed") }}
                    </th>
                    <th class="col-pph">
                      {{ $t("reports.vcloud.col.templatePrice") }}
                    </th>
                    <th class="col-charge">
                      {{ $t("reports.vcloud.col.total") }}
                    </th>
                  </tr>
                  </thead>
                  <tbody v-if="!$IsMobile() && viewLoader && vms.length > 0">
                  <tr
                    v-for="(row, i) in vms"
                    :key="i"
                    :class="{ odd: i % 2 }"
                  >
                    <td class="col-description">{{ row.name }}</td>
                      <td class="col-hours">
                        {{ row.cpu ? row.cpu.vcpu_count : "" }}
                      </td>
                      <td class="col-pph">
                        {{ row.cpu ? row.cpu.price : "" }}
                      </td>
                      <td class="col-hours">
                        {{ row.memory ? row.memory.usage : "" }}
                      </td>
                      <td class="col-pph">
                        {{ row.memory ? row.memory.price : "" }}
                      </td>
                      <td class="col-description">
                        {{
                          formatTemplateNames(
                            row.vm && row.vm.metadata
                              ? row.vm.metadata
                              : row.metadata
                          )
                        }}
                      </td>
                      <td class="col-pph">
                        {{
                          formatTemplatePrice(
                            row.vm && row.vm.metadata
                              ? row.vm.metadata
                              : row.metadata
                          )
                        }}
                      </td>
                    <td class="col-charge">{{ row.total }}</td>
                  </tr>
                  </tbody>
                  <tbody
                    v-else-if="$IsMobile() && viewLoader && vms.length > 0"
                  >
                  <tr
                    v-for="(row, i) in vms"
                    :key="i"
                    :class="{ odd: i % 2 }"
                  >
                    <td>
                        <div>
                          <strong>{{ $t("reports.vcloudDetail.vmId") }}</strong>
                        </div>
                        <div>{{ row.name }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.cpuNumber")
                          }}</strong>
                        </div>
                        <div>{{ row.cpu ? row.cpu.vcpu_count : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.cpuPrice")
                          }}</strong>
                        </div>
                        <div>{{ row.cpu ? row.cpu.price : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.memoryUsage")
                          }}</strong>
                        </div>
                        <div>{{ row.memory ? row.memory.usage : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.memoryPrice")
                          }}</strong>
                        </div>
                        <div>{{ row.memory ? row.memory.price : "" }}</div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.templateUsed")
                          }}</strong>
                        </div>
                        <div>
                          {{
                            formatTemplateNames(
                              row.vm && row.vm.metadata
                                ? row.vm.metadata
                                : row.metadata
                            )
                          }}
                        </div>
                        <br />
                        <div>
                          <strong>{{
                            $t("reports.vcloud.col.templatePrice")
                          }}</strong>
                        </div>
                        <div>
                          {{
                            formatTemplatePrice(
                              row.vm && row.vm.metadata
                                ? row.vm.metadata
                                : row.metadata
                            )
                          }}
                        </div>
                        <br />
                        <div>
                          <strong>{{ $t("reports.vcloud.col.total") }}</strong>
                        </div>
                      <div>{{ row.total }}</div>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-if="viewLoader && vms.length === 0">
                  <tr>
                    <td colspan="8">
                        <span class="noTickets">{{
                            $t("reports.noResult")
                          }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div><MyLoading :viewLoader="viewLoader" type="" /></div>
              </div>
            </div>
          </div>

          <!-- Storage Panel -->
          <div class="mdl-tabs__panel tabTwo">
            <div class="mdl-grid">

              <div class="mdl-cell mdl-cell--12-col">
                <table class="cloud-report-table">
                  <thead v-if="!$IsMobile()">
                  <tr>
                    <th class="col-description">
                      {{ $t("reports.vcloudDetail.storageName") }}
                    </th>
                    <th class="col-hours">
                      {{ $t("reports.vcloudDetail.spaceUsed") }}
                    </th>
                    <th class="col-pph">
                      {{ $t("reports.vcloudDetail.price") }}
                    </th>
                  </tr>
                  </thead>
                  <tbody
                    v-if="!$IsMobile() && viewLoader && storage.length > 0"
                  >
                  <tr
                    v-for="(row, i) in storage"
                    :key="i"
                    :class="{ odd: i % 2 }"
                  >
                    <td class="col-description">{{ row.name }}</td>
                    <td class="col-hours">{{ row.space_used }}</td>
                    <td class="col-pph">{{ row.price }}</td>
                  </tr>
                  </tbody>
                  <tbody
                    v-else-if="$IsMobile() && viewLoader && storage.length > 0"
                  >
                  <tr
                    v-for="(row, i) in storage"
                    :key="i"
                    :class="{ odd: i % 2 }"
                  >
                    <td>
                      <div>
                        <strong>{{
                            $t("reports.vcloudDetail.storageName")
                          }}</strong>
                      </div>
                      <div>{{ row.name }}</div>
                      <br />
                      <div>
                        <strong>{{
                            $t("reports.vcloudDetail.spaceUsed")
                          }}</strong>
                      </div>
                      <div>{{ row.space_used }}</div>
                      <br />
                      <div>
                        <strong>{{
                            $t("reports.vcloudDetail.price")
                          }}</strong>
                      </div>
                      <div>{{ row.price }}</div>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-if="viewLoader && storage.length === 0">
                  <tr>
                    <td colspan="3">
                        <span class="noTickets">{{
                            $t("reports.noResult")
                          }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div><MyLoading :viewLoader="viewLoader" type="" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MyLoading from "@/components/MyLoading.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";

export default {
  name: "VCloudDetail",
  components: { MyBanner, MyHeaderPage, MyLoading },
  data() {
    return {
      detailDate: moment().format("YYYY-MM-DD"),
      projectName: "",
      viewLoader: false,
      vms: [],
      storage: [],
      vProjectsList: [],
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
    };
  },
  methods: {
    formatTemplateNames(metadata) {
      try {
        // Prefer the first element only
        if (Array.isArray(metadata)) {
          const first = metadata[0];
          return first && (first.name || first.label)
            ? first.name || first.label
            : 0;
        }
        // In case an object containing a metadata array is passed
        if (metadata && Array.isArray(metadata.metadata)) {
          const first = metadata.metadata[0];
          return first && (first.name || first.label)
            ? first.name || first.label
            : 0;
        }
        // Fallback: object with usage number
        if (
          metadata &&
          typeof metadata === "object" &&
          typeof metadata.usage !== "undefined"
        ) {
          return String(metadata.usage);
        }
        return 0;
      } catch (e) {
        return 0;
      }
    },
    formatTemplatePrice(metadata) {
      try {
        // Prefer the first element only
        if (Array.isArray(metadata)) {
          const first = metadata[0];
          return typeof (first && first.price) !== "undefined"
            ? first.price
            : 0;
        }
        // In case an object containing a metadata array is passed
        if (metadata && Array.isArray(metadata.metadata)) {
          const first = metadata.metadata[0];
          return typeof (first && first.price) !== "undefined"
            ? first.price
            : 0;
        }
        if (
          metadata &&
          typeof metadata === "object" &&
          typeof metadata.price !== "undefined"
        ) {
          return metadata.price;
        }
        if (typeof metadata === "number") return metadata;
        return 0;
      } catch (e) {
        return 0;
      }
    },
    switchTab(tab) {
      if (tab == 1) {
        try {
          document
            .getElementsByClassName("tabTwo")[0]
            .classList.remove("is-active");
          document
            .getElementsByClassName("tabTwo")[1]
            .classList.remove("is-active");
          document
            .getElementsByClassName("tabOne")[0]
            .classList.add("is-active");
          document
            .getElementsByClassName("tabOne")[1]
            .classList.add("is-active");
        } catch (e) {
          // ignore
        }
      } else {
        try {
          document
            .getElementsByClassName("tabTwo")[0]
            .classList.add("is-active");
          document
            .getElementsByClassName("tabTwo")[1]
            .classList.add("is-active");
          document
            .getElementsByClassName("tabOne")[0]
            .classList.remove("is-active");
          document
            .getElementsByClassName("tabOne")[1]
            .classList.remove("is-active");
        } catch (e) {
          // ignore
        }
      }
    },
    normalizeDateForApi(d) {
      if (!d) return "";
      // Try a few common formats and output YYYY-MM-DD
      const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];
      for (const f of formats) {
        const m = moment(d, f, true);
        if (m.isValid()) return m.format("YYYY-MM-DD");
      }
      // Fallback: parse loosely
      const m = moment(d);
      return m.isValid() ? m.format("YYYY-MM-DD") : "";
    },
    fetchProjects() {
      const date = this.normalizeDateForApi(this.detailDate);
      const base = window.VUE_APP_MISTRA_URL;
      const url = `${base}front/v1/report-cloud-project-names?infrastructure=vcloud&from=${date}&to=${date}`;
      this.axios
        .get(url, { headers: this.he })
        .then((res) => {
          this.vProjectsList =
            res.data && res.data.project_names ? res.data.project_names : [];
          // Map query string to the matching project object if needed
          if (this.projectName) {
            if (typeof this.projectName === "string") {
              const match = this.vProjectsList.find(
                (p) => p && p.name === this.projectName
              );
              if (match) this.projectName = match;
            }
          }
          // Ensure projectName set
          if (!this.projectName && this.vProjectsList.length > 0) {
            this.projectName = this.vProjectsList[0];
          }
          // After projects load, attempt to fetch details
          this.fetchDetails();
        })
        .catch(() => {
          this.vProjectsList = [];
        });
    },
    fetchDetails() {
      const date = this.normalizeDateForApi(this.detailDate);
      if (!date || !this.projectName) return;
      this.viewLoader = false;
      const base = window.VUE_APP_MISTRA_URL;
      const pname =
        typeof this.projectName === "object"
          ? this.projectName.name
          : this.projectName;
      if (!pname) {
        this.viewLoader = true;
        return;
      }
      const url = `${base}front/v1/report-cloud/vcloud/details?date=${date}&project_name=${encodeURIComponent(
        pname
      )}`;
      this.axios
        .get(url, { headers: this.he })
        .then((res) => {
          const data = res.data || {};
          this.vms = Array.isArray(data.vms) ? data.vms : [];
          this.storage = Array.isArray(data.storage) ? data.storage : [];
          this.viewLoader = true;
        })
        .catch((err) => {
          console.error("Error fetching VCloud details:", err);
          this.vms = [];
          this.storage = [];
          this.viewLoader = true;
        });
    },
    onProjectChange() {
      this.fetchDetails();
    },
  },
  mounted() {
    const q = this.$route && this.$route.query ? this.$route.query : {};
    if (q.date) this.detailDate = this.normalizeDateForApi(q.date);
    if (q.project_name) {
      this.projectName =
        typeof q.project_name === "string"
          ? q.project_name
          : q.project_name.name || "";
    }
    // Initialize: fetchProjects will trigger details after loading projects
    this.fetchProjects();
  },
};
</script>

<style scoped>
/* Fix floating label for select in VCloudDetail: move label slightly up to avoid overlap with chosen project */
.cdl-input select:focus ~ label,
.cdl-input select.not-empty ~ label {
  top: -14px;
  transition: all 0.15s ease;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 0;
  font-size: 1rem;
}
</style>
